export const NOT_SENT = "NOT_SENT";
export const SENT = "SENT";
export const READ = "READ";
export const UNDELIVERED = "UNDELIVERED";
